(function () {
  angular
    .module("akitabox.ui.dialogs.schedule.cancel")
    .factory("CancelScheduleDialog", CancelScheduleDialog);

  /* @ngInject */
  function CancelScheduleDialog($log, $q, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl:
        "app/core/ui/dialogs/schedule/cancel/cancel-schedule.dialog.html",
      controller: "CancelScheduleDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.scheduleIDs` and `options.locals.building` are required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error}               Promise that resolves with the canceled schedules
     */
    function show(options) {
      // Verify we have schedule locals
      if (
        !options ||
        !options.locals ||
        !options.locals.schedules ||
        !options.locals.schedules.length > 0
      ) {
        $log.error(
          "CancelScheduleDialog: you must pass in schedules via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
